<template>
  <div class="container" fluid>
    <div class="loading-container">
      <!-- <div class="row">
        <div id="npc-logo" class="col text-center px-auto">
          <svg width="376" height="376" version="1.1" viewBox="0 0 376 376">
            <g stroke-width="1" fill-rule="evenodd">
              <path
                class="fill-red"
                d="M188.000832 16.348514c-94.64968 0-171.652419 77.00234-171.652419 171.651532 0 94.651042 77.002738 171.652458 171.652419 171.652458 94.649681 0 171.653344-77.001416 171.653344-171.652458 0-94.649192-77.003663-171.651532-171.653344-171.651532m0 359.651578c-103.665037 0-188.001017-84.335544-188.001017-188.000046C-.000185 84.336469 84.335795 0 188.000832 0 291.665869 0 376 84.33647 376 188.000046c0 103.664502-84.334131 188.000046-187.999168 188.000046"
              />

              <path
                class="fill-dark-red"
                d="M122.497083 295.879006c-1.877748.60854-30.135241-.205638-24.83638-23.815868 5.317491-23.637215 49.672759-36.160667 57.339297-32.405213-11.178932 4.359341-33.61783 6.477134-44.342228 29.972914-10.567919 23.211981 11.686558 25.896442 11.839311 26.248167"
              />
              <path
                class="fill-blue"
                d="M164 312.389338c-.718635 1.792357-19.196239 22.697351-33.648575 3.665766-14.458743-19.046322 4.123223-60.616837 11.814902-64.055104-3.810137 11.252426-16.380291 29.586778-5.443314 52.671889 10.807897 22.748929 26.898903 7.638239 27.276987 7.717449"
              />
              <path
                class="fill-green"
                d="M203.322426 280c1.57051 1.197328 17.020183 24.953844-5.244596 34.207624-22.274034 9.271566-57.761822-20.026921-59.07783-28.505573 9.920034 6.685001 24.440542 23.963404 49.719552 19.198433C213.63208 300.238489 203.14011 280.354798 203.322426 280"
              />
              <path
                class="fill-red"
                d="M306.130669 157.460233c-55.692284 5.744592-42.28771-.023141-48.105243-23.993809-3.232683.353599-31.740077 32.995769-39.76209 15.46856 2.51544-22.530354 3.573257-26.754101 5.851776-49.248355-7.680514 3.692423-13.986698 11.502144-26.453766 13.836637-1.142036.127739-2.095274.219379-3.574183-.237893C179.206457 103.444773 180.404022 77.833852 174.83359 39c-23.240518 33.866806-27.46716 53.318444-28.040954 61.293856-.816269 3.478598-7.016949 36.843701 34.654395 103.049064 16.980608 26.950339 3.45017 54.942036 1.407647 58.552077 6.203456-6.100043 43.262235-36.864066 40.525607-82.242273 9.679538 26.925347 8.477347 56.036157-6.919774 80.345613-4.997562 7.862483-2.556161 4.278361-7.395467 10.001663 16.919526-5.362298 59.8671 1.786507 68.663736-1.722637-5.13731-6.799835-30.710949-11.551204-15.682167-21.703748 21.67554-20.063493 2.258158-3.305501 24.339056-22.181383-.09625-.619261 29.667013-20.451341 29.614331-20.842892-26.0929-5.842711-11.304742-25.514654-9.869331-46.089107M152.789108 179.833434C156.242485 183.530503 115.864107 124.80548 135.374754 91c0 0-53.227741 46.926832.960412 76.523769.058801.064861 11.164675 6.665843 16.453942 12.309665"
              />
            </g>
          </svg>
        </div>
      </div> -->
      <div class="loading"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#npc-logo {
  svg {
    max-width: 45rem;
    width: 100%;
    height: auto;
    stroke: black;
    stroke-width: 8;

    path {
      stroke-dasharray: 1200;
      stroke-dashoffset: -1200;

      @for $i from 1 through 5 {
        &:nth-of-type(#{$i}) {
          animation: outline 2s #{$i * 350}ms forwards;
          fill-opacity: 0;
        }
      }
    }
    .fill-red {
      fill: #ee3d42;
    }
    .fill-dark-red {
      fill: #bf311a;
    }
    .fill-blue {
      fill: #0069aa;
    }
    .fill-green {
      fill: #008751;
    }
  }
  @keyframes outline {
    70% {
      stroke-opacity: 0.5;
      stroke-dashoffset: 5;
    }
    100% {
      fill-opacity: 1;
      stroke-opacity: 0;
    }
  }
}
.loading-container {
  position: relative;
  width: 50%;
  margin: 280px auto;
  padding: 20px 40px;
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
  // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);

  .loading {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 10px;
    background: #f1f1f1;
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    overflow: hidden;
  }

  .loading:after {
    content: "";
    position: absolute;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 4px;
    // box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    animation: load 3s infinite;
  }
}
@keyframes load {
  0% {
    width: 0;
    background: #a28089;
  }

  25% {
    width: 40%;
    background: #a0d2eb;
  }

  50% {
    width: 60%;
    background: #ffa8b6;
  }

  75% {
    width: 75%;
    background: #d0bdf4;
  }

  100% {
    width: 100%;
    background: #494d5f;
  }
}
</style>
